import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import "font-awesome/css/font-awesome.min.css";
import Vue from "vue";
import Vuetify, { VIcon, VSnackbar, VSkeletonLoader } from "vuetify/lib";
import "tiptap-vuetify/dist/main.css";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/es5/util/colors";
import { Options } from '@fremcast/theme-one'
import ThemeOne from '@fremcast/theme-one'

Vue.use(Vuetify,{
  components: {
    // the components which Toast.vue used
    VIcon,
    VSnackbar,
    VSkeletonLoader
  }
});

const vuetify = new Vuetify(Options);

const opt = { vuetify:vuetify, InitVuetify: Vuetify }
Vue.use(ThemeOne, opt);

export default vuetify;
